var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 25V14.1412C6 13.8298 6.14513 13.5361 6.39255 13.3469L15.3925 6.46452C15.7511 6.19033 16.2489 6.19033 16.6075 6.46452L25.6075 13.3469C25.8549 13.5361 26 13.8298 26 14.1412V25C26 25.5523 25.5523 26 25 26H20.75C20.1977 26 19.75 25.5523 19.75 25V19.3529C19.75 18.8007 19.3023 18.3529 18.75 18.3529H13.25C12.6977 18.3529 12.25 18.8007 12.25 19.3529V25C12.25 25.5523 11.8023 26 11.25 26H7C6.44772 26 6 25.5523 6 25Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIcon1);
export default __webpack_public_path__ + "static/media/m-icon-1.e6a70af8c6d4ae0bd85be0e85da2a7d7.svg";
export { ForwardRef as ReactComponent };